<template>
  <div>
    <loading-component v-if="isLoading"></loading-component>
    <header-component></header-component>
    <div
      v-if="$route.params.type == 0"
      class="container registation_content g-pt-25 g-pb-50"
    >
      <div class="row">
        <div
          class="col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12"
        >
          <div class="g-max-width-645 text-center mx-auto g-mb-0">
            <h2 class="h2 mb-3">Registration Form</h2>
          </div>
          <account-type @clicked="GetForm()"></account-type>
        </div>
      </div>
    </div>

    <div
      v-if="$route.params.type != 0"
      class="g-bg-img-hero"
      style="
        background-image: url('../../../../static/assets/include/svg/svg-bg1.svg');
        background-attachment: fixed;
      "
    >
      <div class="container registation_content g-pt-50 g-pb-50">
        <div class="row justify-content-center">
          <div
            class="col-lg-8 col-md-10 col-sm-12 col-xs-12"
            style="background-color: white; padding: 50px; border-radius: 10px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);"
          >
            <div class="g-max-width-945 text-center mx-auto g-mb-0">
              <h2 class="h2 mb-3">Registration Form</h2>
            </div>
            <div
              v-show="isSubmitFail"
              id="errorDiv"
              class="alert alert-danger alert-dismissible fade show"
              role="alert"
            >
              <button
                type="button"
                @click="isSubmitFail = false"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Error!</strong> Please complete the form to proceed with
              the submission
            </div>
            <div>
              <p class="registration-authority">
                Required fields are denoted with an asterisk
              </p>
              <p>
                Complete the information below to register for a Champions for Sight®
                account. Upon submitting the form, you will be sent an email
                confirmation with a link to activate your account. If you have
                any questions or concerns, please email us at
                <a
                  class="g-font-size-18"
                  href="mailto:support@onesight.org"
                  target="_blank"
                >support@onesight.org</a
                >.
              </p>
              <p class="registration-authority">
                {{ noteLabel }}
              </p>
              <p class="registration-authority">
                Nonprofit organizations, please <a href="cltl.org">click here</a> to register at <a href= "CLTL.org">CLTL.org</a>
              </p>
              <div class="row">
                <non-profit-organization-details
                  :Account="Account"
                  :FormInputs="FormInputs"
                  :AccountValidationResult="AccountValidationResult"
                ></non-profit-organization-details>
                <username-and-password
                  :Account="Account"
                  :FormInputs="FormInputs"
                  :AccountValidationResult="AccountValidationResult"
                  @clicked="IsEmailAddressValid()"
                  @confirm="ValidateConfirmEmail()"
                ></username-and-password>
                <participant-information
                  :Account="Account"
                  :FormInputs="FormInputs"
                  :AccountValidationResult="AccountValidationResult"
                  @npiForBusiness="ValidateNpiNumberForBusinessType()"
                  @npiIsDirty="ValidateNpiNumber()"
                  :ContactValidationResult="ContactValidationResult"
                  :BusinessTypeIndividual="BusinessTypeIndividual"
                  :BusinessTypeBusiness="BusinessTypeBusiness"
                  :BusinessTypeNonProfit="BusinessTypeNonProfit"
                  :Suffix="Suffix"
                  :RoleNonProfit="RoleNonProfit"
                  :RoleBusiness="RoleBusiness"
                  :State="State"
                ></participant-information>
                <office-location-information
                  :Account="Account"
                  :FormInputs="FormInputs"
                  :OfficeLocationValidationResult="
                    OfficeLocationValidationResult
                  "
                  :State="State"
                  :RoleNonProfit="RoleNonProfit"
                  :RoleBusiness="RoleBusiness"
                  @addressCheck="ValidateAddress()"
                  :IsValidNPI="IsValidNPI"
                  :IsAddressValidating="IsAddressValidating"
                ></office-location-information>
                <eye-doctor-information
                  :Account="Account"
                  :FormInputs="FormInputs"
                  :EyeDoctorValidation="EyeDoctorValidation"
                  :Suffix="Suffix"
                  :State="State"
                  @npiIsDirtyBusiness="ValidateNpiNumberEyeDoctor"
                ></eye-doctor-information>
                <association-and-communication
                  :Account="Account"
                  :FormInputs="FormInputs"
                  :CheckboxIndividual="CheckboxIndividual"
                  :CheckboxBusiness="CheckboxBusiness"
                ></association-and-communication>
                <TermAgreementAndBaa
                  :Account="Account"
                  :FormInputs="FormInputs"
                  :AccountValidationResult="AccountValidationResult"
                  :BusinessEmail="BusinessEmail"
                  :TermsEmail="TermsEmail"
                ></TermAgreementAndBaa>
                <div
                  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center g-my-30"
                >
                  <button
                    :disabled="!EnablebCheck()"
                    @click="SubmitForm()"
                    type="submit"
                    class="btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-10 g-font-size-18--md g-font-size-16"
                  >
                    Agree & Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>


<script>
function InitialData() {
  return {
    labels: null,
    isLoading: false,
    FormInputs: null,
    isSubmitFail: false,
    called: "",
    TermsEmail: {
      Subject: "Terms and Conditions",
      Name: "",
      Email: "",
      Message: "",
    },
    BusinessEmail: {
      Subject: "Business Associate Agreement",
      Name: "",
      Email: "",
      Message: "",
    },
    AccountValidateNpi: {},
    Account: {
      // CovidReliefParticipantStatus: null,
      PortalType: window.location.href.includes("championsforsight") ? "CFS" : "CLTL",
      AccountType: null,
      UseLicenseNumber: false,
      NoEyeDoctor: false,
      IsCoveredUnderHIPAA: true,
      IsCoBrandAgreed: true,
      IsLensesAgreementAgreed: true,
      BusinessNpiNumber: null,
      IsOrderFrameKit: false,
      IsPatientChargeAgreed: true,
      IsElectronicLogAgreed: true,
      BusinessAssociateAgreement: true,
      TermAgreement: null,
      ToBeContactedAsVolunteer: true,
      ToReceiveNewsLetter: true,
      isFrameOrderingAllowed: false,
      isFrameKitAllowed: false,
      HowDoYouPlanOnServingThosePatient: [],
      PrimaryContact: {
        IsEyeDoctor: false,
        IsLicenseNumber: false,
        IsPrimaryLicenseNumber: false,
        // IsEyeDoctorsLicenseNumber: false,
        IsMultiLocation: false,
        IsFirstName: false,
        OfficeLocation: {
          Jobs: {},
          StreetAddress: null,
          City: null,
          State: null,
          Zip: null,
          QRDonationCode: null
        },
        LicenseNumber: null,
        State: null,
        NpiNumber: null,
      },
      EyeDoctors: [
        {
          UseLicenseNumber: false,
          NpiNumber: null,
          LicenseNumber: null,
          State: null,
          FirstName: null,
          LastName: null,
          Suffix: null,
          EmailAddress: null,
          YearsInPractice: null,
          Organizations: {
            List: [],
            Others: null,
          },
          NoEyeDoctor: false,
          Role: null,
        },
      ],
      NewsLetter: true,
      Opportunities: true,
      Organizations: {
        List: [],
      },
      ParticipantResponsibilitiesDate:
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear(),
      BusinessAssociateAgreementDate:
        new Date().getMonth() +
        1 +
        "/" +
        new Date().getDate() +
        "/" +
        new Date().getFullYear(),
      PaymentProcessors: {
        List: [],
        Other: null,
      },
      DonationSolutions: {
        List: [],
        Other: null,
      },
    },
    AccountEnums: [
      "Suffix",
      "State",
      "BusinessTypeIndividual",
      "BusinessTypeBusiness",
      "BusinessTypeNonProfit",
      "RoleBusiness",
      "RoleNonProfit",
      "OrganizationIndividual",
      "OrganizationBusinessCFS",
    ],
    State: {},
    Suffix: {},
    BusinessTypeIndividual: {},
    BusinessTypeBusiness: {},
    BusinessTypeNonProfit: {},
    RoleBusiness: {},
    RoleNonProfit: {},
    CheckboxIndividual: {},
    CheckboxBusiness: {},
    AccountValidationResult: {},
    HasEmailAddressError: "",
    HasConfirmEmailAddressError: "",
    ContactValidationResult: {},
    OfficeLocationValidationResult: {
      OfficeLocationJobs: null,
      OfficeLocationNumberOfJobs: null,
      OfficeLocationZip: null,
    },
    EyeDoctorValidation: [
      {
        validationResult: {},
      },
    ],
    IsValidNPI: false,
    IsAddressValidating: false,
  };
}

import HeaderComponent from "@/components/shared/HeaderComponent";
import AccountType from "@/components/registration/AccountType";
import LoadingComponent from "@/components/shared/LoadingComponent";
import FooterComponent from "@/components/shared/FooterComponent";
import NonProfitOrganizationDetails from "@/components/AccountDetails/NonProfitOrganizationDetails";
import UsernameAndPassword from "@/components/AccountDetails/UsernameAndPassword";
import ParticipantInformation from "@/components/AccountDetails/ParticipantInformation";
import OfficeLocationInformation from "@/components/AccountDetails/OfficeLocationInformation";
import EyeDoctorInformation from "@/components/AccountDetails/EyeDoctorInformation";
import AssociationAndCommunication from "@/components/AccountDetails/AssociationAndCommunication";
import TermAgreementAndBaa from "@/components/AccountDetails/TermAgreementAndBaa";
// import CovidRelief from "@/components/AccountDetails/CovidRelief";
export default {
  components: {
    HeaderComponent,
    AccountType,
    LoadingComponent,
    FooterComponent,
    NonProfitOrganizationDetails,
    UsernameAndPassword,
    ParticipantInformation,
    OfficeLocationInformation,
    EyeDoctorInformation,
    AssociationAndCommunication,
    TermAgreementAndBaa,
    // CovidRelief,
  },
  data() {
    return InitialData();
  },
  computed: {
    registrationType: function () {
      var type = null;
      if (this.$route.params.type == "Individual") {
        type = "Individual";
      } else if (this.$route.params.type == "Business") {
        type = "Practice/Business";
      } else if (this.$route.params.type == "NonProfit") {
        type = "Non-Profit";
      }
      return type;
    },
    noteLabel: function () {
      var note = null;
      if (this.$route.params.type == "Individual") {
        note =
          "NOTE:  You must be an eye care professional with a valid NPI number or License number to complete this form.";
      } else if (this.$route.params.type == "Business") {
        note =
          "NOTE: Please ensure you have legal authority to sign agreements on behalf of your company before completing this registration form.";
      } else if (this.$route.params.type == "NonProfit") {
        note =
          "NOTE: Please ensure you have legal authority to sign agreements on behalf of your organization before completing this registration form.";
      }
      return note;
    },
  },
  methods: {
    Reset() {
      Object.assign(this.$data, InitialData());
    },
    GetForm() {
      this.Reset();
      this.GetSelectValues();
      this.FormInputs = this.FieldFlags[this.$route.params.type];
    },
    GetSelectValues() {
      var _this = this;
      axios
        .post("/Util/GetEnums", this.AccountEnums)
        .then(function (response) {
          _this.CheckboxBusiness = response.data.raw.OrganizationBusinessCFS;
          _this.CheckboxIndividual = response.data.raw.OrganizationIndividual;
          _this.State = response.data.raw.State;
          _this.Suffix = response.data.raw.Suffix;
          _this.RoleBusiness = response.data.raw.RoleBusiness;
          _this.RoleNonProfit = response.data.raw.RoleNonProfit;
          _this.BusinessTypeIndividual =
            response.data.raw.BusinessTypeIndividual;
          _this.BusinessTypeBusiness = response.data.raw.BusinessTypeBusiness;
          _this.BusinessTypeNonProfit = response.data.raw.BusinessTypeNonProfit;
          _this.BusinessType = response.data.raw.BusinessType;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    IsEmailAddressValid(event) {
      var _this = this;
      axios
        .get("/Account/IsEmailAddressValid/" + this.Account.EmailAddress + "/" + this.Account.PortalType)
        .then((response) => {
          _this.AccountValidationResult = {
            AccountEmailAddress: response.data.errorMessage,
            AccountEmailAddressConfirm: _this.HasConfirmEmailAddressError,
          };
          _this.HasEmailAddressError = response.data.errorMessage;
          _this.called = _this.AccountValidationResult.AccountEmailAddress;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SubmitForm() {
      if (this.$route.params.type == "Individual") {
        this.Account.EyeDoctors = [];
      }

      if (this.Account.PrimaryContact.FirstName && this.Account.PrimaryContact.LastName) {
        this.Account.PrimaryContact.LegalName =  `${this.Account.PrimaryContact.FirstName || ''} ${this.Account.PrimaryContact.LastName || ''}`.trim();
      }

      if (this.Account.PrimaryContact.OfficeLocation.StreetAddress) {
        let check_PO_BOX = this.checkIfAddressHasPO_BOX(
          this.Account.PrimaryContact.OfficeLocation.StreetAddress.toString()
        );
        if (check_PO_BOX == true) {
          alert(
            "Sorry, our labs cannot ship to a PO BOX. Please enter a valid shipping address."
          );
          return;
        }
      }
      var _this = this;
      console.log("_this.AccountValidationResult");
      console.log(_this.AccountValidationResult);
      let isValid = true;
      if (
        _this.AccountValidationResult.AccountEmailAddress != null ||
        _this.AccountValidationResult.AccountEmailAddressConfirm
      ) {
        isValid = false;
      }
      if (isValid == false) {
        alert("Please make sure all required fields are complete.");
        return;
      }

      if (this.Account.ParticipantResponsibilitiesSignature != null) {
        this.Account.BusinessAssociateAgreementSignature = this.Account.ParticipantResponsibilitiesSignature;
      }

      this.Account.AccountType = this.$route.params.type;
      if (sessionStorage.getItem("referralCode")) {
        this.Account.ReferralCode = sessionStorage.getItem("referralCode");
      }

      this.isLoading = true;
      if (!_this.Account.IsCoveredUnderHIPAA)
        _this.Account.BusinessAssociateAgreement = "true";

      // To get the total number of jobs
      var numberOfJobs =
        _this.Account.PrimaryContact.OfficeLocation.NumberOfJobs;
      if (numberOfJobs < 100) {
        console.log("if (numberOfJobs < 100) {");
        _this.Account.PrimaryContact.OfficeLocation.Jobs = {
          january: null,
          february: null,
          march: null,
          april: null,
          may: null,
          june: null,
          july: null,
          august: null,
          september: null,
          october: null,
          november: null,
          december: null,
        };
        console.log("this.Account.PrimaryContact.OfficeLocation");
        console.log(this.Account.PrimaryContact.OfficeLocation);
        this.Account.PrimaryContact.OfficeLocation.Jobs =
          _this.Account.PrimaryContact.OfficeLocation.Jobs;
      }
      var totalOfJobs = _this.SaveTotalJobs(
        _this.Account.PrimaryContact.OfficeLocation.Jobs
      );
      if (numberOfJobs < totalOfJobs) {
        _this.Account.PrimaryContact.OfficeLocation.NumberOfJobs = totalOfJobs;
        this.Account.PrimaryContact.OfficeLocation.NumberOfJobs = totalOfJobs;
      }
      console.log("Account/SaveChanges this.Account");
      console.log(this.Account);
      axios

        .post("Account/Register/CFS", this.Account)
        .then(function (response) {
          _this.AccountValidationResult = response.data.raw.validationResult;
          console.log("_this.AccountValidationResult");
          console.log(_this.AccountValidationResult);
          _this.ContactValidationResult =
            response.data.raw.primaryContact.validationResult;
          _this.OfficeLocationValidationResult =
            response.data.raw.primaryContact.officeLocation.validationResult;
          _this.EyeDoctorValidation = response.data.raw.eyeDoctors;
          _this.isLoading = false;
          if (response.data.isSuccess == true) {
            _this.$router.push({
              name: "RegistrationSuccess",
              query: { salesforceId: response.data.raw.salesforceId },
            });
          } else {
            if (
              _this.$route.params.type == 2 &&
              _this.$route.query.BusinessNpiNumber != ""
            ) {
              console.log("fail to register business");
            }
            // if(_this.$route.params.type == 2 && _this.$route.query.BusinessNpiNumber != ''){
            //   console.log("_this.$route.params.type == 0")
            //   console.log(_this.$route.params.type == 2)
            //     // business npi
            //     var individualNpiValidationResult = _this.AccountValidationResult.AccountNpiNumber;
            //     _this.AccountValidationResult = {
            //       AccountBusinessNpiNumber: response.data.errorMessage,
            //       AccountNpiNumber: individualNpiValidationResult
            //     };
            //     // _this.called = _this.AccountValidationResult.AccountBusinessNpiNumber;
            //     // _this.Account.PrimaryContact.LegalName = null;
            //     // _this.isLoading = false;
            //   }

            _this.isSubmitFail = true;
            _this.$scrollTo("#errorDiv", 300, {
              el: "#errorDiv",
              offset: -100,
              x: false,
              y: true,
            });
          }
        })
        .catch(function (error) {
          _this.isLoading = false;
          console.log(error);
          _this.$router.push({ name: "Error" });
        });
    },
    EnablebCheck() {
      let isEnabled = false;
      if (this.Account.TermAgreement == "true" && this.Account.ParticipantResponsibilitiesSignature) {
        isEnabled = true
      }
      return isEnabled
    },
    ValidateAddress() {
      var _this = this;

      if (true) {
        _this.IsAddressValidating = true;
        var params = {
          Address2: _this.Account.PrimaryContact.OfficeLocation.StreetAddress,
          City: _this.Account.PrimaryContact.OfficeLocation.City,
          State: _this.Account.PrimaryContact.OfficeLocation.State,
          Zip5: _this.Account.PrimaryContact.OfficeLocation.Zip,
        };
        axios
          .post("/Account/GetAddressDetails/", params)
          .then((response) => {
            if (response.data.isSuccess) {
              var details = response.data.raw;
              _this.Account.PrimaryContact.OfficeLocation.StreetAddress =
                details.address2;
              _this.Account.PrimaryContact.OfficeLocation.City = details.city;
              _this.Account.PrimaryContact.OfficeLocation.State = details.state;
              _this.Account.PrimaryContact.OfficeLocation.Zip = details.zip5;
              _this.OfficeLocationValidationResult.OfficeLocationZip = null;
              _this.IsAddressValidating = false;
              _this.IsValidNPI = true;
            } else {
              _this.OfficeLocationValidationResult.OfficeLocationZip =
                response.data.errorMessage;
              _this.IsAddressValidating = false;
              _this.IsValidNPI = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    ValidateConfirmEmail(event) {
      var _this = this;
      if (_this.Account.EmailAddress != _this.Account.EmailAddressConfirm) {
        _this.AccountValidationResult = {
          AccountEmailAddress: _this.HasEmailAddressError,
          AccountEmailAddressConfirm: "Email address does not match",
        };
        _this.HasConfirmEmailAddressError = "Email address does not match";
      } else {
        _this.AccountValidationResult.AccountEmailAddressConfirm = null;
        _this.HasConfirmEmailAddressError = null;
      }
    },
    ValidateNpiNumber() {
      var _this = this;
      var npiNumber = _this.Account.NpiNumber;
      if (npiNumber.length == 10) {
        _this.isLoading = true;
        _this.AccountValidateNpi.AccountType = this.$route.params.type;
        _this.AccountValidateNpi.NpiNumber = npiNumber;

        axios
          .post("/Account/IsNpiNumberValid", _this.AccountValidateNpi)
          .then((response) => {
            if (response.data.isSuccess) {
              _this.AccountValidationResult = { AccountNpiNumber: null };
              var details = response.data.raw.results[0];
              var basicDetails = details.basic;
              var address = details.addresses[0];
              _this.Account.PrimaryContact.FirstName = basicDetails.first_name;
              _this.Account.PrimaryContact.LastName = basicDetails.last_name;
              _this.Account.PrimaryContact.Suffix = basicDetails.credential;
              _this.Account.PrimaryContact.CountryCode = address.telephone_number.split(
                "-"
              )[0];
              _this.Account.PrimaryContact.AreaCode = address.telephone_number.split(
                "-"
              )[1];
              _this.Account.PrimaryContact.Phone = address.telephone_number.split(
                "-"
              )[2];
              _this.isLoading = false;
              if (_this.Account.PrimaryContact.IsEyeDoctor) {
                _this.Account.EyeDoctors[0].NpiNumber = _this.Account.NpiNumber;
              }
            } else {
              var businessNpiValidationResult =
                _this.AccountValidationResult.AccountBusinessNpiNumber;
              _this.AccountValidationResult = {
                AccountNpiNumber: response.data.errorMessage,
                AccountBusinessNpiNumber: businessNpiValidationResult,
              };
              _this.called = _this.AccountValidationResult.AccountNpiNumber;
              _this.Account.PrimaryContact.FirstName = null;
              _this.Account.PrimaryContact.LastName = null;
              _this.Account.PrimaryContact.Suffix = null;
              _this.Account.PrimaryContact.CountryCode = null;
              _this.Account.PrimaryContact.AreaCode = null;
              _this.Account.PrimaryContact.Phone = null;
              _this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    ValidateNpiNumberForBusinessType() {
      var _this = this;
      var npiNumber = _this.Account.BusinessNpiNumber;
      if (npiNumber.length == 10) {
        _this.isLoading = true;
        _this.AccountValidateNpi.AccountType = this.$route.params.type;
        _this.AccountValidateNpi.BusinessNpiNumber = npiNumber;

        axios
          .post("/Account/IsNpiNumberBusinessType", _this.AccountValidateNpi)
          .then((response) => {
            if (response.data.isSuccess) {
              _this.AccountValidationResult = { AccountNpiNumber: null };
              var details = response.data.raw.results[0];
              var basicDetails = details.basic;
              var address = details.addresses[0];

              var legalName = this.ConvertToTitleCase(basicDetails.name);
              _this.Account.PrimaryContact.LegalName = legalName;
              _this.isLoading = false;
            } else {
              var individualNpiValidationResult =
                _this.AccountValidationResult.AccountNpiNumber;
              _this.AccountValidationResult = {
                AccountBusinessNpiNumber: response.data.errorMessage,
                AccountNpiNumber: individualNpiValidationResult,
              };
              _this.called =
                _this.AccountValidationResult.AccountBusinessNpiNumber;
              _this.Account.PrimaryContact.LegalName = null;
              _this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    ValidateNpiNumberEyeDoctor(index) {
      var _this = this;
      var npiNumber = _this.Account.EyeDoctors[index].NpiNumber;
      if (npiNumber.length == 10) {
        _this.isLoading = true;
        _this.AccountValidateNpi.AccountType = this.$route.params.type;
        _this.AccountValidateNpi.NpiNumber = npiNumber;

        axios
          .post("/Account/IsNpiNumberValidEyeDoctor/", _this.AccountValidateNpi)
          .then((response) => {
            if (response.data.isSuccess) {
              var details = response.data.raw.results[0];
              var basicDetails = details.basic;
              var address = details.addresses[0];

              _this.Account.EyeDoctors[
                index
                ].FirstName = _this.ConvertToTitleCase(basicDetails.first_name);
              _this.Account.EyeDoctors[
                index
                ].LastName = _this.ConvertToTitleCase(basicDetails.last_name);
              _this.Account.EyeDoctors[index].Suffix = basicDetails.credential;

              _this.EyeDoctorValidation[index].validationResult = {
                EyeDoctorNpiNumber: null,
              };

              _this.isLoading = false;
            } else {
              _this.Account.EyeDoctors[index].FirstName = null;
              _this.Account.EyeDoctors[index].LastName = null;
              _this.Account.EyeDoctors[index].Suffix = null;

              _this.EyeDoctorValidation[index].validationResult = {
                EyeDoctorNpiNumber: response.data.errorMessage,
              };

              _this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    SaveTotalJobs(job) {
      return (
        (job.January ? parseInt(job.January) : 0) +
        (job.February ? parseInt(job.February) : 0) +
        (job.March ? parseInt(job.March) : 0) +
        (job.April ? parseInt(job.April) : 0) +
        (job.May ? parseInt(job.May) : 0) +
        (job.June ? parseInt(job.June) : 0) +
        (job.July ? parseInt(job.July) : 0) +
        (job.August ? parseInt(job.August) : 0) +
        (job.September ? parseInt(job.September) : 0) +
        (job.October ? parseInt(job.October) : 0) +
        (job.November ? parseInt(job.November) : 0) +
        (job.December ? parseInt(job.December) : 0)
      );
    },
  },
  created() {
    this.GetForm();
    if (sessionStorage.getItem("referralCode")) {
      this.Account.ReferralCode = sessionStorage.getItem("referralCode");
    } else if(this.$route.query.referralcode) {
      sessionStorage.setItem(
        "referralCode",
        this.$route.query.referralcode
      );
      this.Account.ReferralCode = this.$route.query.referralcode
    }

    var referralcode = this.$route.query.referralcode || null;

    console.log("Created:");
    console.log("this.$route");
    console.log(this.$route);
    console.log("this.$route.query");
    console.log(this.$route.query);
    console.log("this.$route.params.type");
    console.log(this.$route.params.type);
    // Number("0") ? 0 : null

    if (
      this.$route.query.NpiNumber ||
      this.$route.query.BusinessNpiNumber ||
      this.$route.query.NumberOfJobs ||
      this.$route.query.EmailAddress
    ) {
      // http://localhost:8080/Registration/Business?EmailAddress=samuel%40gmail.com&EmailAddressConfirm=samuel%40gmail.com&Password=asdf1234&PasswordConfirm=asdf1234&CountryCode=870&AreaCode=763&Phone=1700&LegalName=1%20Advamced%20In-home%20Care,%20Llc&FirstName=Anes&LastName=Abraham&Suffix=OD&NpiNumber=1972067882&State=MO&IsEyeDoctor=false&LicenseNumber=1234567890&BusinessNpiNumber=1231241212&YearsInPractice=2011&office_StreetAddress=1521%20N%2010TH%20ST&IsMultiLocation=false&office_CountryCode=223&office_AreaCode=322&office_Phone=2233&office_City=BLYTHEVILLE&Role=Optician&BusinessType=IndependentPractice&ToReceiveNewsLetter=true&ToBeContactedAsVolunteer=true&office_State=AR&office_Zip=72315&office_Suite=SUITE%20H&org1=Lions%20Club&org2=Vision%20Source&org3=Partners%20in%20Vision&doctor1_UseLicenseNumber=false&doctor1_NpiNumber=1407398290&doctor1_State=AR&doctor1_FirstName=Sam&doctor1_LastName=Mayeda&doctor1_Suffix=OD&doctor1_EmailAddress=businessqa%40test.com&doctor1_YearsInPractice=2016&doctor2_UseLicenseNumber=false&doctor2_NpiNumber=1932197167&doctor2_LicenseNumber=null&doctor2_State=AR&doctor2_FirstName=Cristina&doctor2_LastName=Ackerman&doctor2_Suffix=OD&doctor2_EmailAddress=businessqa%40test.com&doctor2_YearsInPractice=1999
      console.log("AutoFill mode");
      let org = [];
      let doctors = [];


      for (let index = 1; index < 100; index++) {
        let d = {
          UseLicenseNumber:
            this.$route.query[`doctor${index}_UseLicenseNumber`] == "true"
              ? true
              : false,
          NpiNumber: Number(this.$route.query[`doctor${index}_NpiNumber`])
            ? this.$route.query[`doctor${index}_NpiNumber`]
            : null,
          LicenseNumber:
            this.$route.query[`doctor${index}_LicenseNumber`] || undefined,
          State: this.$route.query[`doctor${index}_State`] || undefined,
          FirstName: this.$route.query[`doctor${index}_FirstName`],
          LastName: this.$route.query[`doctor${index}_LastName`],
          Suffix: this.$route.query[`doctor${index}_Suffix`],
          EmailAddress: this.$route.query[`doctor${index}_EmailAddress`],
          YearsInPractice: this.$route.query[`doctor${index}_YearsInPractice`],
          Organizations: {
            List: [],
            Others: null,
          },
          NoEyeDoctor: false,
          UseLicenseNumber:
            this.$route.query[`doctor${index}_UseLicenseNumber`] == "true"
              ? true
              : false,
        };
        if (this.$route.query[`doctor${index}_FirstName`]) {
          console.log("this.$route.query[`doctor${index}_FirstName`]");
          this.EyeDoctorValidation.push({ validationResult: {} });
          // AccountNpiNumber
          doctors.push(d);
        }
      }

      for (let index = 1; index < 20; index++) {
        console.log(`org${index}`);
        org.push(this.$route.query[`org${index}`]);
      }

      this.Account.UseLicenseNumber =
        this.$route.query.UseLicenseNumber || false;
      this.Account.NoEyeDoctor =
        this.$route.query.NoEyeDoctor == "true" ? true : false;
      this.Account.NpiNumber = Number(this.$route.query.NpiNumber)
        ? this.$route.query.NpiNumber
        : null;
      this.Account.BusinessNpiNumber = Number(
        this.$route.query.BusinessNpiNumber
      )
        ? this.$route.query.BusinessNpiNumber
        : null;
      // this.Account.IsCoveredUnderHIPAA = this.$route.query.IsCoveredUnderHIPAA
      // this.Account.isFrameOrderingAllowed = this.$route.query.isFrameOrderingAllowed
      // this.Account.isFrameKitAllowed = this.$route.query.isFrameKitAllowed
      this.Account.ToBeContactedAsVolunteer =
        this.$route.query.ToBeContactedAsVolunteer == "true" ? true : false;
      this.Account.ToReceiveNewsLetter =
        this.$route.query.ToReceiveNewsLetter == "true" ? true : false;
      this.Account.NewsLetter =
        this.$route.query.ToBeContactedAsVolunteer == "true" ? true : false;
      this.Account.Opportunities =
        this.$route.query.ToReceiveNewsLetter == "true" ? true : false;

      // this.Account.PrimaryContact = this.Account.PrimaryContact
      this.Account.PrimaryContact.YearsInPractice =
        this.$route.query.YearsInPractice || null;
      //  this.Account.PrimaryContact.IsEyeDoctor =  this.$route.query.IsEyeDoctor == 'true' ? true : false
      this.Account.PrimaryContact.IsLicenseNumber =
        this.$route.query.UseLicenseNumber == "true" ? true : false;
      this.Account.PrimaryContact.UseLicenseNumber =
        this.$route.query.UseLicenseNumber == "true" ? true : false;
      this.Account.PrimaryContact.IsPrimaryLicenseNumber =
        this.$route.query.IsPrimaryLicenseNumber == "true" ? true : false;
      this.Account.PrimaryContact.IsMultiLocation =
        this.$route.query.IsMultiLocation == "true" ? true : false;
      this.Account.PrimaryContact.IsFirstName = false;
      (this.Account.PrimaryContact.OfficeLocation.Jobs = {}),
        (this.Account.PrimaryContact.OfficeLocation.NumberOfJobs =
          this.$route.query.NumberOfJobs || null),
        (this.Account.PrimaryContact.OfficeLocation.StreetAddress =
          this.$route.query.office_StreetAddress || null),
        (this.Account.PrimaryContact.OfficeLocation.City =
          this.$route.query.office_City || null),
        (this.Account.PrimaryContact.OfficeLocation.State =
          this.$route.query.office_State || null),
        (this.Account.PrimaryContact.OfficeLocation.Zip =
          this.$route.query.office_Zip || null),
        (this.Account.PrimaryContact.OfficeLocation.Suite =
          this.$route.query.office_Suite || null),
        (this.Account.PrimaryContact.OfficeLocation.CountryCode =
          this.$route.query.office_CountryCode || null),
        (this.Account.PrimaryContact.OfficeLocation.AreaCode =
          this.$route.query.office_AreaCode || null),
        (this.Account.PrimaryContact.OfficeLocation.Phone =
          this.$route.query.office_Phone || null),
        (this.Account.PrimaryContact.OfficeLocation.QRDonationCode =
          this.$route.query.office_QRDonationCode || null),
        (this.Account.PrimaryContact.NpiNumber = Number(
          this.$route.query.NpiNumber
        )
          ? this.$route.query.NpiNumber
          : null);
      this.Account.PrimaryContact.LicenseNumber =
        this.$route.query.LicenseNumber || null;
      this.Account.PrimaryContact.State = this.$route.query.State;
      this.Account.PrimaryContact.CountryCode = this.$route.query.CountryCode;
      this.Account.PrimaryContact.AreaCode = this.$route.query.AreaCode;
      this.Account.PrimaryContact.Phone = this.$route.query.Phone;
      this.Account.PrimaryContact.FirstName = this.$route.query.FirstName;
      this.Account.PrimaryContact.LastName = this.$route.query.LastName;
      this.Account.PrimaryContact.Suffix = this.$route.query.Suffix;
      this.Account.PrimaryContact.BusinessType = this.$route.query.BusinessType;

      console.log("this.Account.PrimaryContact");
      console.log(this.Account.PrimaryContact);

      if (this.$route.params.type != "Individual") {
        this.Account.PrimaryContact.LegalName = this.$route.query.LegalName;
        this.Account.PrimaryContact.Title = this.$route.query.Role;

        if (this.Account.PrimaryContact.IsEyeDoctor == false) {
          this.Account.NpiNumber = null;
        }
        if (doctors.length != 0) {
          this.Account.EyeDoctors = doctors;
          console.log("adding doctors: ");
          console.log(this.Account.EyeDoctors);
        }
      }

      if (
        this.Account.PrimaryContact.IsEyeDoctor == false &&
        this.$route.params.type == "Business"
      ) {
        this.Account.NpiNumber = null;
        this.Account.PrimaryContact.NpiNumber = null;
      }

      (this.Account.Organizations = {
        List: org.filter((w) => w != undefined),
      }),
        (this.Account.EmailAddress = this.$route.query.EmailAddress),
        (this.Account.EmailAddressConfirm = this.$route.query.EmailAddressConfirm);
      this.Account.Password = this.$route.query.Password;
      this.Account.PasswordConfirm = this.$route.query.PasswordConfirm;
      this.Account.State = this.$route.query.State;
      this.IsEmailAddressValid();
      this.ValidateAddress();
      // this.ValidateNpiNumber();
      // this.ValidateNpiNumberForBusinessType();
    }

    console.log("this.Account");
    console.log(this.Account);
  }
};
</script>



// WEBPACK FOOTER //
// Registration.vue?b46e0e04